import { Div, Container, RightDiv, LogoCanto } from './styles';
import DoctorLoginView from '../../views/DoctorLogin/index.jsx';
import logoCanto from '../../assets/logoCanto.png';

import { deleteCookies } from '../../utils/functions';

function LoginDoctor() {


  // Deleta cookies ao montar o componente
  deleteCookies();

  return (
    
    <Div>
      <Container>
        <RightDiv>
            <LogoCanto src={logoCanto} alt="Logo Cantoneira" /> 
          <DoctorLoginView />
        </RightDiv>
      </Container>
    </Div>
  );
}

export default LoginDoctor;
